/* DERMOVA: confirmed bundle diagnostics. Native Shopify/Meta owns all standard events and CAPI. */
(() => {
  'use strict';
  if (window.DermovaTracking) return;
  const PIXEL = '1081193947323101';
  const EVENT = 'DermovaBundleConfirmed';
  const PRODUCTS = new Map([[53904624812325, 10683699134757], [52010115039479, 10186931437815]]);
  const seen = new Set();
  const pending = new Map();
  let privacyLoading = false;
  let sent = 0;
  const integer = value => Number.isSafeInteger(Number(value)) && Number(value) >= 0;
  function permitted() {
    try {
      const api = window.Shopify?.customerPrivacy;
      return api?.analyticsProcessingAllowed?.() === true && api?.marketingAllowed?.() === true && api?.saleOfDataAllowed?.() === true;
    } catch { return false; }
  }
  function buildBundlePayload(detail) {
    const cart = detail?.cart;
    if (!cart || cart.__provisional || cart.currency !== 'ARS' || !Array.isArray(cart.items) || !cart.items.length || cart.items.some(line => line.__provisional)) return null;
    const pricing = window.DERMOVACartPricing;
    if (typeof pricing?.validate !== 'function' || pricing.validate(cart)?.ok !== true) return null;
    const requested = new Map();
    for (const item of detail?.items || []) {
      const id = Number(item.id), quantity = Number(item.quantity);
      if (!PRODUCTS.has(id)) continue;
      if (!integer(quantity) || quantity < 1) return null;
      requested.set(id, (requested.get(id) || 0) + quantity);
    }
    if (!requested.size || !PRODUCTS.has(Number(detail?.source?.baseVariantId))) return null;
    const contents = [], ids = new Set();
    let addedCents = 0, numItems = 0, cartCents = 0;
    for (const line of cart.items) {
      if (!integer(line.final_line_price)) return null;
      cartCents += Number(line.final_line_price);
    }
    for (const [id, quantity] of requested) {
      const lines = cart.items.filter(line => Number(line.variant_id || line.id) === id && Number(line.product_id) === PRODUCTS.get(id));
      if (!lines.length || lines.some(line => !integer(line.quantity) || Number(line.quantity) < 1)) return null;
      const currentQuantity = lines.reduce((n, line) => n + Number(line.quantity), 0);
      if (currentQuantity < quantity) return null;
      const finalCents = lines.reduce((n, line) => n + Number(line.final_line_price), 0);
      const allocation = Math.round(finalCents * quantity / currentQuantity);
      addedCents += allocation; numItems += quantity; ids.add(String(PRODUCTS.get(id)));
      contents.push({ id: String(PRODUCTS.get(id)), quantity, item_price: Math.round(finalCents / currentQuantity) / 100 });
    }
    if (!integer(addedCents) || addedCents < 1 || !integer(cartCents)) return null;
    return { currency: 'ARS', value: addedCents / 100, content_type: 'product_group', content_ids: [...ids], contents, num_items: numItems, cart_value: cartCents / 100, bundle_units: numItems, price_basis: 'confirmed_discounted_cart_allocation' };
  }
  function send(id, payload, attempt = 0) {
    if (!permitted()) { pending.delete(id); return; }
    // Reuse the native SDK. Never initialize a second pixel or load another SDK.
    if (typeof window.fbq === 'function') {
      try { window.fbq('trackSingleCustom', PIXEL, EVENT, payload, { eventID: id }); sent += 1; } catch {}
      pending.delete(id); return;
    }
    if (attempt >= 10) { pending.delete(id); return; }
    pending.set(id, setTimeout(() => send(id, payload, attempt + 1), 200));
  }
  function confirmed(event) {
    try {
      // Fail closed; never replay actions performed with unknown or denied permissions.
      if (!permitted()) return;
      const detail = event.detail, token = detail?.transactionId;
      if (typeof token !== 'string' || !/^[a-zA-Z0-9_-]{8,100}$/.test(token)) return;
      const id = 'dermova_bundle_' + token;
      if (seen.has(id)) return;
      const payload = buildBundlePayload(detail); if (!payload) return;
      seen.add(id); if (seen.size > 200) seen.delete(seen.values().next().value);
      send(id, payload);
    } catch { /* Analytics must never block a purchase or cart update. */ }
  }
  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy?.marketingAllowed || privacyLoading || typeof window.Shopify?.loadFeatures !== 'function') return;
    privacyLoading = true;
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { privacyLoading = false; }); } catch { privacyLoading = false; }
  }
  document.addEventListener('tdm:cart:added', confirmed);
  document.addEventListener('visitorConsentCollected', () => {
    if (permitted()) return;
    for (const timeout of pending.values()) clearTimeout(timeout);
    pending.clear();
  });
  window.addEventListener('pagehide', () => { for (const timeout of pending.values()) clearTimeout(timeout); pending.clear(); });
  window.DermovaTracking = Object.freeze({ version: '1.0.0', buildBundlePayload, status: () => ({ permitted: permitted(), sdkPresent: typeof window.fbq === 'function', sent, pending: pending.size }) });
  loadPrivacy();
})();
